import { type PropsWithChildren, useMemo } from 'react';
import { WidgetFiltersProvider } from '@elfsight/widget-filters';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { capitalize } from 'es-toolkit';
import { useTranslation } from 'react-i18next';

export function FiltersWithThemeProvider({ children }: PropsWithChildren) {
  const { t } = useTranslation();
  const { filtersAndSearchColor, activeFiltersColor } = useSettings();

  const theme = useMemo(
    () => ({
      textColor: filtersAndSearchColor,
      accentColor: activeFiltersColor,
      modalBackground: getInvertedColor(filtersAndSearchColor)
    }),
    [filtersAndSearchColor, activeFiltersColor]
  );

  return (
    <WidgetFiltersProvider
      theme={theme}
      i18n={{
        Apply: capitalize(t('apply')),
        Clear: t('Clear'),
        'Show Less': t('Show less'),
        'Show More': t('Show more')
      }}
    >
      {children}
    </WidgetFiltersProvider>
  );
}
